webpackJsonp([195850678278728],{

/***/ 427:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(81);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  var tags = {};
	
	  posts.forEach(function (post) {
	    if (Array.isArray(post.node.frontmatter.tags)) {
	      post.node.frontmatter.tags.forEach(function (tag) {
	        if (!tags[tag]) {
	          tags[tag] = 0;
	        }
	
	        tags[tag]++;
	      });
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'tags' },
	    Object.keys(tags).map(function (key) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { key: key, role: 'button', to: '/tags/' + key, className: 'btn btn-default btn-sm' },
	        key + ' (' + tags[key] + ')'
	      );
	    })
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tags-js-947e9c0dc3a4fa9114eb.js